import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { PosService } from "src/app/core/services/pos.service";
import { OOCanvas } from "src/app/shared/models/oo-canvas";

@Component({
	selector: "app-pos-canvas-ribbon",
	templateUrl: "./pos-canvas-ribbon.component.html",
	styleUrls: ["./../../../pos.scss"],
})
export class PosCanvasRibbonComponent implements OnInit {
	@Input() canvasSelected: OOCanvas;
	@Output() canvasSelectedChange = new EventEmitter<OOCanvas>();
	constructor(public posService: PosService) {}

	ngOnInit(): void {}

	selectCanvas(canvasKey: number) {
		this.canvasSelectedChange.emit(this.posService.venueService.ooCanvases.find((i) => i.canvasKey === canvasKey));
	}
}
